export interface CronOption {
  label: string; // e.g. "8:00"
  value: string; // e.g. "0 8 * * 1-5"
}

export const CRON_OPTIONS: CronOption[] = Array.from({ length: 24 }, (_, h) => ({
  label: `${h}:00`,
  value: `0 ${h} * * 1-5`,
}));

export function isKnownCronSchedule(value: string): boolean {
  return CRON_OPTIONS.some((opt) => opt.value === value);
}
